// extracted by mini-css-extract-plugin
export default {"title-with-role__mark":"PricingView_title-with-role__mark__V7Pzr"};